import {isInclusivelyAfterDay} from "react-dates";
import moment from "moment";

export const isBeforeDay = (a, b) => {
    if (!moment.isMoment(a) || !moment.isMoment(b)) return false;

    const aYear = a.year();
    const aMonth = a.month();

    const bYear = b.year();
    const bMonth = b.month();

    const isSameYear = aYear === bYear;
    const isSameMonth = aMonth === bMonth;

    if (isSameYear && isSameMonth) return a.date() < b.date();
    if (isSameYear) return aMonth < bMonth;
    return aYear < bYear;
};

export const isBlockedDayInAdvance = (day, limits) => {
    return !!(
        limits &&
        limits.max_days_before &&
        !isBeforeDay(day, moment().add(limits.max_days_before, 'days'))
    );
};

export const isBlockedMinDaysInAdvance = (day, limits) => {
    return !!(
        limits &&
        limits.min_days_before &&
        isBeforeDay(day, moment().add(limits.min_days_before, 'days'))
    );
};

export const getOutsideRangeByLimits = (
    day,
    limits,
    startDate,
    endDate,
    withBlockBeforeToday,
    focusedInput,
    available_from,
    available_to
) => {
    if(withBlockBeforeToday && !isInclusivelyAfterDay(day, moment())) {
        return true;
    }
    if(focusedInput !== 'endDate' && isBlockedDayInAdvance(day, limits)) {
        return true
    }
    // if(isBlockedMinDaysInAdvance(day, limits)) {
    //    return true;
    // }
    if( startDate && limits && limits.max_nights && isInclusivelyAfterDay(day,moment(startDate).startOf('day')
                    .add(limits.max_nights + 1, 'days'))) {
        return true;
    }
    if( startDate && endDate && limits && limits.max_nights && focusedInput !== 'endDate'
        && moment(endDate).diff(moment(startDate), 'days') > limits.max_nights) {
        return true;
    }
    if( !!available_from && !!available_to ){
        const sameYear = available_from.month() <= available_to.month() ;

        if(sameYear){
            if( moment(day.format("MM-DD")).isBefore(moment(available_from.format("MM-DD")), 'day') ||
                moment(day.format("MM-DD")).isAfter(moment(available_to.format('MM-DD')), 'day') )
            {
                return true;
            }
            return false;
        }
        else{

            let adjusted_from = available_from.set('year', day.year());
            let adjusted_to = available_to.set('year', day.year() + 1);
            if(day.month() < available_from.month() ){
                adjusted_from = available_from.set('year', day.year() -1);
                adjusted_to = available_to.set('year', day.year());
            }

            if(moment(day.format("YYYY-MM-DD")).isBetween( moment(adjusted_from.format("YYYY-MM-DD")), moment(adjusted_to.format("YYYY-MM-DD")), null, "[]") ){
                return false;
            }
            else{
                return true;
            }
        }

    }

     return false;
};
